module.exports = __webpack_public_path__ + "static/img/envelope02thai.d2ed45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope02thai.png
// module id = 7dMv
// module chunks = 1